'use strict'

/**
 * Project easytitle24 app
 * Created by hielo on 2018-05-29
 */

import ProjectTakeoff from './takeoff.vue'

const routes = [
	{
		path: '/project/takeoff/:id/:tab?',
		name: 'project.takeoff',
		component: ProjectTakeoff,
		props: true,
		meta: { authRequired: true }
	}
]

export default routes



// WEBPACK FOOTER //
// ./src/app/take-off-tool/index.js